<!--
 * @Author: your name
 * @Date: 2020-01-13 16:16:13
 * @LastEditTime : 2020-01-13 16:48:53
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \operation-mobile\src\pages\sysMaintenance.vue
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <div id='main-container' class="main-container flexClass">
               <div class="boxWrapper">
                    <img class="box-img" src="../assets/img/notFound/sys-maintance@2x.png" alt="">
                    <p class="box-text">系统维护中…</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

};
</script>
<style lang="scss" scoped>
.boxWrapper {
    text-align: center;
    .box-img {
        width: 200px;
    }
    .box-text {
        font-size: 14px;
        color: #999;
        margin-top: 16px;
    }
}
</style>
